import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import isEqual from 'lodash/isEqual'
import { l } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { SubmitRef } from 'apps/aiAutomation/components/EngagementGoalEditor/lib/types'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { BotAssigneePicker } from 'common/settings/components/BotAssigneePicker'
import { OnChangeTargetProps } from 'common/settings/components/BotAssigneePicker/interfaces'
import { ExitActionType, LeadQualExitAction } from 'shared/api/requests/aiEngagementGoal/schemas'

import { ExitActionProps } from '../../lib/types'

export const AssignConversationAction = forwardRef<SubmitRef<LeadQualExitAction>, ExitActionProps>(
  ({ exitActionData, isActive }: ExitActionProps, ref) => {
    const dispatch = useAppDispatch()

    const [assignee, setAssignee] = useState(
      exitActionData && exitActionData.type === ExitActionType.ASSIGN_CONVERSATION
        ? exitActionData.data.assignee
        : null,
    )

    const [hasError, setHasError] = useState(false)

    const onChange = ({ target }: Record<'target', OnChangeTargetProps>) => {
      setHasError(false)
      setAssignee(target)
    }

    useEffect(() => {
      if (!exitActionData || exitActionData.type !== ExitActionType.ASSIGN_CONVERSATION) {
        dispatch(AiAutomationLayoutActions.confirmChanged({ show: isActive }))
        return
      }

      if (isActive) {
        const hasChanges = !isEqual(exitActionData.data.assignee, assignee)
        dispatch(AiAutomationLayoutActions.confirmChanged({ show: hasChanges }))
      } else {
        dispatch(AiAutomationLayoutActions.confirmChanged({ show: false }))
      }
    }, [assignee, dispatch, exitActionData, isActive])

    useImperativeHandle(
      ref,
      () => ({
        submit: async () => {
          if (!assignee) {
            setHasError(true)
            return { isValid: false }
          }

          return {
            isValid: true,
            data: {
              type: ExitActionType.ASSIGN_CONVERSATION,
              data: {
                assignee,
              },
            },
          }
        },
      }),
      [assignee],
    )

    return (
      <div>
        <BotAssigneePicker
          disabled={!isActive}
          value={assignee ? assignee.user_id || assignee.group_id : null}
          invalid={hasError}
          errorText={l.translate('Choose a team member or a group to continue')}
          onChange={onChange}
        />
      </div>
    )
  },
)
